import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, Card, Chip, IconButton, CardContent, Grid, Paper, Container, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme, Stack } from '@mui/material';
import { Menu as MenuIcon, Help as HelpIcon } from '@mui/icons-material';
// app UI controller for toggling sidenav
import { useMaterialUIController, setMiniSidenav } from "context";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import SouthIcon from '@mui/icons-material/South';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  Legend,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import {
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";
import FilterPanelContainer from "components/Filter/Filterpopup"
import KpiMetricscards from "components/KPI/KpiMetricscards";
import TimeSeriescards from "components/TimeSeries/TimeSeriescards";
import HighlightsCards from "components/Highlights/Highlightscard";
import Visualizations from "components/Visualizations/Visualizations";
import PieLegendCard from "components/Visualizations/Piecharts"
import Barcharts from "components/Visualizations/Barcharts"
import LineChartSubBrand from "components/Visualizations/Linechartsubbrand";
import LineChartsale from "components/Visualizations/LineChartsale"
import InventoryCharts from "components/Visualizations/Inventorycharts";
import WaterfallChart from "components/Visualizations/waterfallchart";
import TopSkuBarChart from "components/Visualizations/SkuBarchart";
import MultiBarcharts from "components/Visualizations/MultiBarcharts";
import datadrilldown from "assets/images/selectedicons/DataDrillDown.svg";
import drillDownArrow from "assets/images/selectedicons/DrillDownArrow.svg";
import datadrillhover from 'assets/images/selectedicons/Data Drill Down1.svg';
import FilterChip from "components/FilterChip/FilterChip";

const geoUrl =
  "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const usaData = {
  TX: 80,
  CA: 65,
  NY: 55,
  FL: 45,
  WA: 35,
  GA: 50,
};
const stateCodes = {
  1: "AL", 2: "AK", 4: "AZ", 5: "AR", 6: "CA",
  8: "CO", 9: "CT", 10: "DE", 12: "FL", 13: "GA",
  16: "ID", 17: "IL", 18: "IN", 19: "IA", 20: "KS",
  21: "KY", 22: "LA", 23: "ME", 24: "MD", 25: "MA",
  26: "MI", 27: "MN", 28: "MS", 29: "MO", 30: "MT",
  31: "NE", 32: "NV", 33: "NH", 34: "NJ", 35: "NM",
  36: "NY", 37: "NC", 38: "ND", 39: "OH", 40: "OK",
  41: "OR", 42: "PA", 44: "RI", 45: "SC", 46: "SD",
  47: "TN", 48: "TX", 49: "UT", 50: "VT", 51: "VA",
  53: "WA", 54: "WV", 55: "WI", 56: "WY"
};
const getColor = (value) => {
  if (value >= 75) return "rgba(76, 175, 80, 1)";
  if (value >= 50) return "rgba(76, 175, 80, 0.6)";
  if (value >= 25) return "rgba(76, 175, 80, 0.25)";
  return "#BDBDBD";
};
const legendColors = [
  "rgba(76, 175, 80, 1)",
  "rgba(76, 175, 80, 0.6)",
  "rgba(76, 175, 80, 0.25)",
  "#BDBDBD",
];
// --- BAR CHART DATA ---
const barData = [
  { name: "RED BULL", value: 4.7, color: "#000000" },
  { name: "MONSTER", value: 3.4, color: "#333333" },
  { name: "CELSIUS", value: 1.3, color: "#555555" },
  { name: "ALANI", value: 0.8, color: "#777777" },
  { name: "GHOST", value: 0.4, color: "#AAAAAA" },
  { name: "C4", value: 0.4, color: "#f7e600" },
  { name: "ROCKSTAR", value: 0.3, color: "#DDDDDD" },
  { name: "NOS", value: 0.3, color: "#BCBCBC" },
  { name: "FUEL", value: 0.2, color: "#dcdcdc" },
  { name: "BLOOM", value: 0.1, color: "#e2d7ff" },
];
const data = [
  { name: "Jan. 2025", a: 501, b: 752, c: 92 },
  { name: "Feb. 2025", a: 492, b: 806, c: 144 },
  { name: "Mar. 2025", a: 689, b: 1017, c: 88 },
  { name: "Apr. 2025", a: 528, b: 1005, c: 223 },
  { name: "May. 2025", a: 741, b: 1114, c: 172 },
  { name: "Jun. 2025", a: 755, b: 1002, c: 184 },
  { name: "Jul. 2025", a: 651, b: 1094, c: 169 },
  { name: "Aug. 2025", a: 654, b: 1167, c: 251 },
  { name: "Sep. 2025", a: 749, b: 996, c: 168 },
  { name: "Oct. 2025", a: 651, b: 1152, c: 248 },
  { name: "Nov. 2025", a: 762, b: 1052, c: 164 },
  { name: "Dec. 2025", a: 841, b: 1247, c: 148 },
];
// ---- DONUT DATA ----
const donutData = [
  {
    title: "TBD",
    value: 43,
    colors: ["#0d6efd", "#133b5c"], // Blue shades
    legends: ["TBD", "TBD"]
  },
  {
    title: "TBD",
    value: 43,
    colors: ["#d4af37", "#4b0082"], // Gold + Purple
    legends: ["TBD", "TBD"]
  },
  {
    title: "TBD",
    value: 43,
    colors: ["#1c8d3f", "#a00000"], // Green + Red
    legends: ["TBD", "TBD"]
  }
];
const OperationsDashboard = ({ subcategoryToken: propSubcategoryToken }) => {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Below 900px
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Between 900px and 1200px
  // State for API data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const header = document.querySelector('.MuiAppBar-root');
    if (header) {
      header.style.display = 'none';
    }
  }, []);
  // Toggle sidenav from the page menu icon
  const isTogglingSidenavRef = useRef(false);
  const handleToggleSidenav = useCallback(() => {
    if (isTogglingSidenavRef.current) return;
    isTogglingSidenavRef.current = true;
    // Defer to next frame to avoid blocking heavy charts paint
    requestAnimationFrame(() => {
      setMiniSidenav(dispatch, !miniSidenav);
      setTimeout(() => {
        isTogglingSidenavRef.current = false;
      }, 150);
    });
  }, [dispatch, miniSidenav]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
      } catch (error) {
        console.error('Failed loading static mocks or transforming data:', error);
        setError('Failed to load static mock data. Check competitive_analysis/data/allMocks.json');
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, [location.search, propSubcategoryToken]);


  // KPIs cards section data 
  const Kpiscardsdata = [
    {
      title: "Stock Amount (Cases)",
      values: [
        { label: "MTD", change: "2.0%", value: "8.27M", status: "increase" },
        { label: "QTD", change: "3.7%", value: "8.39M", status: "increase" },
        { label: "YTD", change: "4.1%", value: "8.53M", status: "increase" }
      ]
    },
    {
      title: "Stock Amount (Dollars)",
      values: [
        { label: "MTD", change: "1.2%", value: "$97.6M", status: "increase" },
        { label: "QTD", change: "2.4%", value: "$99.2M", status: "increase" },
        { label: "YTD", change: "3.1%", value: "$100.38M", status: "increase" }
      ]
    },
    {
      title: "Inventory Turnover (Units)",
      values: [
        { label: "MTD", change: "1.0%", value: "7.7", status: "increase" },
        { label: "QTD", change: "2.2%", value: "7.8", status: "increase" },
        { label: "YTD", change: "2.9%", value: "7.9", status: "increase" }
      ]
    },
    {
      title: "Perfect Order Rate (OTIF)",
      values: [
        { label: "MTD", change: "0.6%", value: "89.7%", status: "increase" },
        { label: "QTD", change: "0.7%", value: "88.9%", status: "increase" },
        { label: "YTD", change: "-1.8%", value: "87.6%", status: "decrease" }
      ]
    },
    {
      title: "On Time Delivery (OT)",
      values: [
        { label: "MTD", change: "0.8%", value: "94.1%", status: "increase" },
        { label: "QTD", change: "1.3%", value: "93.6%", status: "increase" },
        { label: "YTD", change: "-2.4%", value: "92.5%", status: "decrease" }
      ]
    },
    {
      title: "Order Fill Rate (IF)",
      values: [
        { label: "MTD", change: "0.5%", value: "91.0%", status: "increase" },
        { label: "QTD", change: "0.9%", value: "90.3%", status: "increase" },
        { label: "YTD", change: "-1.1%", value: "89.0%", status: "decrease" }
      ]
    },
    {
      title: "Backorder Rate",
      values: [
        { label: "MTD", change: "3.2%", value: "3.9%", status: "increase" },
        { label: "QTD", change: "4.0%", value: "4.1%", status: "increase" },
        { label: "YTD", change: "5.2%", value: "4.5%", status: "increase" }
      ]
    },
    {
      title: "Forecast Accuracy (MAPE)",
      values: [
        { label: "MTD", change: "0.3%", value: "14.8%", status: "increase" },
        { label: "QTD", change: "0.7%", value: "15.2%", status: "increase" },
        { label: "YTD", change: "1.4%", value: "16.1%", status: "increase" }
      ]
    },
    {
      title: "Freight as a Percentage of Revenue",
      values: [
        { label: "MTD", change: "0.8%", value: "7.4%", status: "increase" },
        { label: "QTD", change: "1.3%", value: "7.8%", status: "increase" },
        { label: "YTD", change: "-2.4%", value: "7.1%", status: "decrease" }
      ]
    }
  ];

  //second section timeSeriesCardsdata 
  const timeSeriesCardsdata = [
    {
      title: "Stock Amount (Cases)",
      values: [
        { label: "Nov 2024", change: "+3.7%", value: "7.98M", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+1.4%", value: "8.27M", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+1.4%", value: "8.15M", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Stock Amount (Dollars)",
      values: [
        { label: "Nov 2024", change: "+3.7%", value: "$94.1M", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+1.4%", value: "$97.6M", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+1.4%", value: "$96.2M", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Inventory Turnover (Units)",
      values: [
        { label: "Nov 2024", change: "+2.2%", value: "7.53", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.6%", value: "7.70", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.6%", value: "7.65", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Perfect Order Rate (OTIF)",
      values: [
        { label: "Nov 2024", change: "+2.3%", value: "87.4%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.7%", value: "89.7%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.7%", value: "89.0%", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "On Time Delivery (OT)",
      values: [
        { label: "Nov 2024", change: "+2.4%", value: "91.7%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.7%", value: "94.1%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.7%", value: "93.4%", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Order Fill Rate (IF)",
      values: [
        { label: "Nov 2024", change: "+2.4%", value: "88.6%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.7%", value: "91.0%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.7%", value: "90.3%", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Backorder Rate",
      values: [
        { label: "Nov 2024", change: "+0.2%", value: "3.75%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.8%", value: "3.9%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.8%", value: "3.82%", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Forecast Accuracy (MAPE)",
      values: [
        { label: "Nov 2024", change: "+1.1%", value: "13.7%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "+0.5%", value: "14.8%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "+0.5%", value: "14.3%", status: "increase", arrow: "left" }
      ]
    },

    {
      title: "Freight as a Percentage of Revenue",
      values: [
        { label: "Nov 2024", change: "+0.5%", value: "6.9%", status: "increase", arrow: "right" },
        { label: "Nov 2025", change: "-0.2%", value: "7.4%", status: "nochange", arrow: null },
        { label: "Oct 2025", change: "-0.2%", value: "7.6%", status: "decrease", arrow: "left" }
      ]
    }
  ];

  // third section cards 
  const highlightCards = [
    // --- Backordered SKU ---
    {
      title: "#1 Backordered SKU",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "4.2 M",
      topRightLabel: "NET SALES",
      topRightValue: "$9.8 M",
      bigTitle: "C4 Frozen Bombsicle 16oz",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "3.9 M"
    },
    {
      title: "#2 Backordered SKU",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "3.6 M",
      topRightLabel: "NET SALES",
      topRightValue: "$8.4 M",
      bigTitle: "C4 Starburst Strawberry 16oz",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "3.3 M"
    },
    {
      title: "#3 Backordered SKU",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "2.9 M",
      topRightLabel: "NET SALES",
      topRightValue: "$6.7 M",
      bigTitle: "C4 Orange Slice 16oz",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "2.6 M"
    },

    // --- Lowest OTIF Customers ---
    {
      title: "#1 Lowest OTIF Customer",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "12.4 M",
      topRightLabel: "NET SALES",
      topRightValue: "$27.8 M",
      bigTitle: "Wawa",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "11.8 M"
    },
    {
      title: "#2 Lowest OTIF Customer",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "9.3 M",
      topRightLabel: "NET SALES",
      topRightValue: "$20.6 M",
      bigTitle: "CVS",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "8.9 M"
    },
    {
      title: "#3 Lowest OTIF Customer",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "7.8 M",
      topRightLabel: "NET SALES",
      topRightValue: "$17.4 M",
      bigTitle: "Safeway",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "7.4 M"
    },

    // --- Lowest OTIF Fulfillment Warehouse ---
    {
      title: "#1 Lowest OTIF Fulfillment Warehouse",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "21.8 M",
      topRightLabel: "NET SALES",
      topRightValue: "$48.3 M",
      bigTitle: "SFH",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "20.1 M"
    },
    {
      title: "#2 Lowest OTIF Fulfillment Warehouse",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "18.6 M",
      topRightLabel: "NET SALES",
      topRightValue: "$41.2 M",
      bigTitle: "NELF",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "17.4 M"
    },
    {
      title: "#3 Lowest OTIF Fulfillment Warehouse",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: "15.9 M",
      topRightLabel: "NET SALES",
      topRightValue: "$35.9 M",
      bigTitle: "SERD",
      bottomLabel: "UNITS SOLD LY",
      bottomValue: "14.8 M"
    }
  ];


  const [openFilters, setOpenFilters] = useState(false);
  const handleToggleFilters = () => {
    setOpenFilters((prev) => !prev);
  };

  // Filter state
  const [activeFilter, setActiveFilter] = useState('All');
  const [filterLoading, setFilterLoading] = useState(false);

  // Define filter presets for each quick filter
  const getFilterPreset = useCallback((filterName) => {
    const allCompanies = ["Nutrabolt", "Bloom"];
    const allCategories = ["Functional Beverage", "Active Nutrition"];
    const allBrands = ["C4", "Cellucor", "XTEND", "Bloom"];
    const allSubBrands = ["C4", "C4 Performance", "C4 Smart Energy", "C4 Ultimate", "XTEND", "Bloom Sparkling Energy", "Bloom Pop"];
    const allRoutes = ["Ecommerce", "Direct", "DSD"];
    const allChannels = ["Ecommerce", "Convenience Chain", "Convenience Independent", "Drug", "Food", "Multi Outlet", "Mass"];

    switch (filterName) {
      case 'All':
        return {
          Company: allCompanies,
          Category: allCategories,
          Brand: allBrands,
          "Sub-Brand": allSubBrands,
          "Route to Market": allRoutes,
          Channel: allChannels,
        };
      case 'Nutrabolt':
        return {
          Company: ["Nutrabolt"],
          Category: allCategories,
          Brand: ["C4", "Cellucor", "XTEND"],
          "Sub-Brand": ["C4", "C4 Performance", "C4 Smart Energy", "C4 Ultimate", "XTEND"],
          "Route to Market": allRoutes,
          Channel: allChannels,
        };
      case 'Bloom':
        return {
          Company: ["Bloom"],
          Category: ["Functional Beverage"],
          Brand: ["Bloom"],
          "Sub-Brand": ["Bloom Sparkling Energy", "Bloom Pop"],
          "Route to Market": allRoutes,
          Channel: allChannels,
        };
      case 'Functional Beverage':
        return {
          Company: allCompanies,
          Category: ["Functional Beverage"],
          Brand: ["C4", "Bloom"],
          "Sub-Brand": ["C4 Performance", "C4 Smart Energy", "C4 Ultimate", "Bloom Sparkling Energy", "Bloom Pop"],
          "Route to Market": allRoutes,
          Channel: allChannels,
        };
      case 'Active Nutrition':
        return {
          Company: ["Nutrabolt"],
          Category: ["Active Nutrition"],
          Brand: ["C4", "Cellucor", "XTEND"],
          "Sub-Brand": ["C4", "XTEND"],
          "Route to Market": allRoutes,
          Channel: allChannels,
        };
      default:
        return null;
    }
  }, []);

  const [filterPresets, setFilterPresets] = useState(() => getFilterPreset('All'));

  // Handle filter click with full-page loader
  const handleFilterClick = (filter) => {
    if (filter === activeFilter || filterLoading) return;

    setFilterLoading(true);
    setLoading(true); // Show full-page loader

    // Simulate loading delay
    setTimeout(() => {
      const preset = getFilterPreset(filter);
      setActiveFilter(filter);

      // Set the preset - this will trigger FilterPanelContainer to apply it
      if (preset) {
        setFilterPresets(preset);
      } else {
        setFilterPresets(null);
      }

      setFilterLoading(false);
      setLoading(false); // Hide full-page loader

      // Open filter panel for "Custom" filter
      if (filter === 'Custom') {
        setOpenFilters(true);
      }
    }, 800);
  };

  // Handle filter changes from FilterPanelContainer
  const handleFiltersChange = useCallback((newFilters) => {
    // Don't check for preset match if we're already in Custom mode
    // FilterPanelContainer's isApplyingPresetRef prevents callback when applying presets
    if (activeFilter === 'Custom') return;

    // Check if the current filters match any preset
    const presetNames = ['All', 'Nutrabolt', 'Bloom', 'Functional Beverage', 'Active Nutrition'];
    let matchedPreset = null;

    for (const presetName of presetNames) {
      const preset = getFilterPreset(presetName);
      if (preset) {
        const isMatching = Object.keys(preset).every(key => {
          const presetValues = [...(preset[key] || [])].sort();
          const currentValues = [...(newFilters[key] || [])].sort();
          return presetValues.length === currentValues.length &&
            presetValues.every((val, idx) => val === currentValues[idx]);
        });

        if (isMatching) {
          matchedPreset = presetName;
          break;
        }
      }
    }

    // If filters don't match any preset, switch to Custom
    if (!matchedPreset && activeFilter !== 'Custom') {
      setActiveFilter('Custom');
      setFilterPresets(null);
    }
  }, [activeFilter, getFilterPreset]);
  const [activeIdx, setActiveIdx] = React.useState(0);
  const kpiBriefData = [
    {
      title: "Month",
      value: "$ 65.2 M",
      lyValue: "59.12 M",
      pct: "5.8%",
      positive: true,
      status: "increase",
      glvalue: "$ 85.5 M"
    },
    {
      title: "Quarter",
      value: "$ 180.6 M",
      lyValue: "160.29 M",
      pct: "11.9%",
      positive: true,
      status: "increase",
      glvalue: "$ 207.3 M"
    },
    {
      title: "Year",
      value: "$ 859.1 M",
      lyValue: "823.03 M",
      pct: "5.6%",
      positive: true,
      status: "increase",
      glvalue: "$ 882.8 M"
    }
  ];


  const pieDataSubBrand = [
    { label: "C4 Powder", value: 8, color: "#C7D244" },
    { label: "Bloom Pop", value: 6, color: "#6CA655" },
    { label: "Bloom Sparkling Energy", value: 12, color: "#BD93E3" },
    { label: "XTEND", value: 8, color: "#D0D0D0" },
    { label: "Cellucor", value: 10, color: "#A6A6A6" },
    { label: "C4 Ultimate", value: 6, color: "#000000" },
    { label: "C4 Smart Energy", value: 5, color: "#3FB4E5" },
    { label: "C4 Performance", value: 45, color: "#E8D22F" },
  ];

  const pieDataRegion = [
    { label: "West", value: 18, color: "#4BB056" },
    { label: "North", value: 7, color: "#BFD3EA" },
    { label: "South", value: 14, color: "#9962CC" },
    { label: "South Central", value: 20, color: "#F0C287" },
    { label: "Northeast", value: 17, color: "#E15242" },
    { label: "Central", value: 30, color: "#DBD88B" },


  ];

  const pieDataWarehouse = [

    { label: "SERD", value: 16, color: "#5068AE" },
    { label: "REDP", value: 10, color: "#A4BF52" },
    { label: "SHPL", value: 5, color: "#9B3B68" },
    { label: "SFH", value: 35, color: "#0A6B71" },
    { label: "NELF", value: 34, color: "#DE7C29" },
  ];




  const pieDataCustomers = [
    { label: "Other", value: 18, color: "#D8A62F" },
    { label: "Watkins Distributing", value: 7, color: "#0A8F6B" },
    { label: "Great Basin Beverage", value: 14, color: "#F190A3" },
    { label: "BJ’s", value: 20, color: "#D63D6C" },
    { label: "7-Eleven", value: 17, color: "#000000" },
    { label: "Sam’s Club", value: 30, color: "#1E446C" },
  ];

  const lineChartCasesData = {
    title: "Cases In Stock vs Ordered Over Time",

    xLabels: [
      "Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025",
      "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025",
      "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"
    ],

    series: [
      { key: "stock", label: "Cases In Stock", color: "#A44EE6" },
      { key: "sold", label: "Cases Sold", color: "#4243AC" },
      { key: "forecast", label: "Demand Forecast", color: "#AA2759", dashed: true }
    ],

    // ORDER OF VALUES IN EACH ROW = stock, sold, forecast
    dataMatrix: [
      [6.5, 4.9, 4.9],  // Dec
      [7.3, 5.7, 4.5],  // Jan
      [7.9, 5.9, 4.1],  // Feb
      [6.2, 5.3, 4.8],  // Mar
      [8.1, 5.9, 4.6],  // Apr
      [8.5, 6.1, 5.6],  // May
      [9.0, 6.0, 5.5],  // Jun
      [8.6, 6.0, 6.7],  // Jul
      [9.2, 6.2, 7.5],  // Aug
      [7.9, 5.9, 6.3],  // Sep
      [8.1, 6.0, 5.8],  // Oct
      [9.0, 6.2, 5.8]   // Nov
    ],
    yTicks: [0, 2, 4, 6, 8, 10]

  };

  const otifFailsByWarehouse = {
    title: "OTIF Fails by Warehouse",

    xLabels: [
      "Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025",
      "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025",
      "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"
    ],

    series: [
      { label: "SFH", color: "#0B7D70" },      // teal
      { label: "NELF", color: "#E27826" },     // orange
      { label: "SERD", color: "#5C7AEA" },     // blue
      { label: "REDP", color: "#7C9A27" },     // green
      { label: "SHPL", color: "#B12F7A" }      // magenta
    ],

    // Extracted from image totals & visually estimated segment heights
    dataMatrix: [
      // SFH, NELF, SERD, REDP, SHPL
      [180, 900, 50, 120, 147],   // Dec = 1397
      [200, 950, 60, 140, 234],   // Jan = 1584
      [170, 860, 65, 140, 69], // = 1304
      [157.0, 794.2, 60.0, 129.2, 63.6],
      [165, 900, 70, 145, 34],   // Apr = 1314
      [175, 930, 65, 155, 155],   // May = 1480
      [160, 880, 60, 150, 44],   // Jun = 1294
      [155, 820, 70, 145, 12],   // Jul = 1202
      [150, 830, 65, 160, 62],   // Aug = 1267
      [170, 900, 80, 180, 192],   // Sep = 1522
      [180, 920, 85, 185, 205],   // Oct = 1575
      [220, 1000, 90, 200, 242]   // Nov = 1752
    ]
  };

  const lineChartSubBrandData = {
    title: "Cases Ordered vs Forecasted by Sub Brand",

    xLabels: [
      "Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025",
      "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025",
      "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"
    ],

    series: [
      { label: "C4 Powder", color: "#C2CF2D" },
      { label: "C4 Performance", color: "#ECD01C" },
      { label: "C4 Smart Energy", color: "#1BA4E6" },
      { label: "C4 Ultimate", color: "#1A1A1A" },
      { label: "Cellucor", color: "#747474" },
      { label: "XTEND", color: "#C5C5C5" },
      { label: "Bloom Sparkling Energy", color: "#C393E4" },
      { label: "Bloom Pop", color: "#59A671" }
    ],

    dataMatrix: {
      actual: [
        [3.0, 3.8, 1.4, 2.2, 1.1, 1.7, 0.8, 0.3], // Dec
        [3.1, 4.2, 1.5, 2.4, 1.3, 1.8, 1.3, 0.4], // Jan
        [3.0, 4.4, 1.8, 2.2, 1.5, 1.6, 1.0, 0.8], // Feb
        [3.2, 4.3, 1.6, 2.6, 1.0, 1.4, 1.2, 0.5], // Mar
        [3.3, 4.0, 1.7, 2.6, 1.2, 1.5, 1.3, 0.7], // Apr
        [3.8, 4.5, 2.1, 3.3, 1.7, 2.0, 1.8, 1.1], // May
        [3.9, 4.1, 2.4, 3.0, 2.2, 1.9, 1.6, 0.9], // Jun
        [3.6, 4.2, 1.9, 3.1, 1.6, 1.4, 1.9, 1.0], // Jul
        [3.8, 4.4, 2.2, 3.3, 2.1, 1.8, 1.7, 1.3], // Aug
        [3.7, 4.0, 2.2, 3.0, 2.0, 1.7, 1.6, 1.4], // Sep
        [3.6, 4.3, 2.6, 3.2, 2.3, 1.9, 2.3, 1.9], // Oct
        [3.8, 4.5, 2.9, 3.0, 2.6, 2.1, 2.5, 2.1]  // Nov
      ],

      forecast: [
        [2.9, 4.1, 1.3, 2.6, 1.0, 1.6, 1.1, 0.4], // Dec
        [3.2, 4.0, 1.6, 2.4, 1.1, 1.5, 1.2, 0.3], // Jan
        [3.1, 4.2, 1.5, 2.4, 1.7, 1.4, 1.0, 0.6], // Feb
        [3.0, 4.1, 1.3, 2.5, 1.6, 1.5, 1.1, 0.4], // Mar
        [3.2, 4.1, 1.8, 2.5, 1.4, 1.7, 1.3, 0.8], // Apr
        [3.6, 4.2, 1.9, 3.0, 2.0, 1.9, 1.6, 1.0], // May
        [3.7, 4.2, 2.0, 2.9, 1.7, 1.6, 1.4, 0.8], // Jun
        [3.5, 3.9, 1.8, 3.0, 1.6, 1.6, 1.3, 0.7], // Jul
        [3.7, 4.1, 2.0, 3.1, 1.9, 1.7, 1.5, 1.2], // Aug
        [3.5, 4.0, 2.1, 2.9, 1.7, 1.5, 1.6, 1.1], // Sep
        [3.7, 4.2, 2.3, 3.0, 1.9, 1.6, 1.8, 1.5], // Oct
        [3.9, 4.0, 2.5, 3.2, 2.0, 1.7, 2.0, 1.7]  // Nov
      ]
    }
  };

  const topSkuBackorderChartData = {
    title: "Top 10 Backordered SKUs",

    xLabels: [
      "Cellucor Whey – Chocolate – 2lb",
      "C4 Ultimate – Midnight Cherry – 16oz",
      "C4 Smart Energy – Blood Orange – 12oz",
      "C4 Original – Frozen Bombsicle – 12oz RTD (24-pack)",
      "C4 Performance – Frozen Bombsicle – 16oz",
      "C4 Performance – Blue Ice – 12pk",
      "C4 Smart Energy – Peach Mango – 12oz",
      "C4 Smart Energy – Cherry Berry – 16oz",
      "C4 Smart Energy – Blue Razz – 12oz",
      "C4 Ultimate – Bombsicle – 16oz"
    ],

    series: [
      { label: "Backordered Cases", key: "backordered", color: "#000000" },
      { label: "Cases In Stock", key: "stock", color: "#A24CE1" }
    ],

    dataMatrix: {
      actual: [
        [1943, 882], // SKU 1
        [1725, 552], // SKU 2
        [1562, 623], // SKU 3
        [1461, 425], // SKU 4
        [1331, 614], // SKU 5
        [1242, 432], // SKU 6
        [1052, 578], // SKU 7
        [989, 752],  // SKU 8
        [823, 471],  // SKU 9
        [745, 402]   // SKU 10
      ]
    }
  };

  const topStockedSkuChartData = {
    title: "Top 10 Stocked SKUs",

    xLabels: [
      "C4 Ultimate – Citrus Blaze – 12oz",
      "C4 Ultimate – Tropic Storm – 16oz",
      "Cellucor BCAA Sport – Watermelon – 30srv",
      "XTEND BCAA – Watermelon Explosion – 30srv",
      "Cellucor BCAA Sport – Blue Razz – 30srv",
      "Bloom Sparkling – Grapefruit – 12oz",
      "Bloom Sparkling – Peach – 12oz",
      "Bloom Pop – Blue Razz – 12oz",
      "Cellucor Whey – Vanilla – 2lb",
      "Cellucor Whey – Chocolate – 2lb"
    ],

    series: [
      { label: "Cases In Stock", key: "inStock", color: "#A24CE1" },
      { label: "Cases Sold", key: "sold", color: "#243A74" }
    ],

    dataMatrix: {
      actual: [
        [3956, 1532], // Citrus Blaze
        [3231, 1998], // Tropic Storm
        [3096, 1116], // Watermelon BCAA
        [2821, 1992], // XTEND
        [2210, 834],  // Blue Razz BCAA
        [1994, 1007], // Grapefruit
        [1745, 126],  // Peach
        [1340, 1092], // Bloom Pop Blue Razz
        [1301, 256],  // Whey Vanilla
        [1252, 531]   // Whey Chocolate
      ]
    }
  };

  const overtime = {
    "title": "OTIF, OT, and IF Over Time",
    "xLabels": [
      "Dec. 2025",
      "Jan. 2025",
      "Feb. 2025",
      "Mar. 2025",
      "Apr. 2025",
      "May. 2025",
      "Jun. 2025",
      "Jul. 2025",
      "Aug. 2025",
      "Sep. 2025",
      "Oct. 2025",
      "Nov. 2025"
    ],
    "series": [
      {
        "label": "Perfect Order Rate (OTIF)",
        "color": "#0B5ED7"
      },
      {
        "label": "On Time Delivery (OT)",
        "color": "#00A86B"
      },
      {
        "label": "Order Fill Rate (IF)",
        "color": "#FF8C42"
      }
    ],
    "dataMatrix": [
      [89, 93, 90],
      [83, 97, 88],
      [86, 95, 90],
      [88, 97, 94],
      [87, 98, 89],
      [86, 96, 91],
      [84, 96, 94],
      [86, 93, 88],
      [85, 94, 92],
      [86, 96, 94],
      [85, 96, 89],
      [89, 97, 91]
    ],
    "yTicks": [75, 80, 85, 90, 95, 100]
  }

  const [hover, setHover] = React.useState(false);
  return (


    <Box sx={{
      ml: 0,
      transition: "margin-left 0.25s ease",
      "& .MuiBox-root": { backgroundImage: "none" }
    }} style={{
      padding: isMobile ? '8px' : '0px 16px 0px 16px',
      fontFamily: 'inter !important'
    }} className="top-bar-custom">
      {/* Loading Backdrop */}
      <Backdrop
        open={loading}
        sx={{
          position: 'fixed',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        }}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <Box
        sx={{
          height: {
            xs: "calc(100dvh - 140px)", // mobile header
            md: "calc(100vh - 64px)",  // desktop header
          },
          overflowY: "auto",
          // px: isMobile ? 1 : 2,
          pb: "100px",
          /* smooth scrolling */
          scrollBehavior: "smooth",
          WebkitOverflowScrolling: "touch", // iOS momentum

          /* hide scrollbar */
          scrollbarWidth: "none",          // Firefox
          msOverflowStyle: "none",         // IE / Edge
          "&::-webkit-scrollbar": {
            display: "none",               // Chrome / Safari
          },
        }}
      >
        {/* Section Title: KPI's */}
        <Typography sx={{ fontSize: '16px', mb: 1, mt: 3 }}>
          <span style={{ color: '#1672B980', fontWeight: 200, fontSize: "16px" }}>Operations / </span><span style={{ fontWeight: 200, fontSize: "16px" }}>KPI's</span>
        </Typography>
        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
        <KpiMetricscards cardsData={Kpiscardsdata} kpiBriefData={kpiBriefData} />

        {/* Section Title: Time Series */}
        <Typography sx={{ fontSize: '16px', mb: 1, mt: 3 }}>
          <span style={{ color: '#1672B980', fontWeight: 200, fontSize: "16px" }}>Operations / </span><span style={{ fontWeight: 200, fontSize: "16px" }}>Time Series</span>
        </Typography>
        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
        <TimeSeriescards timeSeriesCards={timeSeriesCardsdata} />

        {/* Section Title: Highlights with YTD/QTD/MTD buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 3 }}>
          <Typography sx={{ fontSize: '16px' }}>
            <span style={{ color: '#1672B980', fontWeight: 200, fontSize: "16px" }}>Operations / </span><span style={{ fontWeight: 200, fontSize: "16px" }}>Highlights</span>
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {['YTD', 'QTD', 'MTD'].map((label, idx) => (
              <FilterChip
                key={label}
                label={label}
                idx={idx}
                activeIdx={activeIdx}
                onClick={setActiveIdx}
              />
            ))}
          </Box>
        </Box>
        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
        <HighlightsCards data={highlightCards} />

        <Box sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography sx={{ fontSize: '16px' }}>
              <span style={{ color: "#1672B980", fontWeight: 200, fontSize: "16px" }}>Operations / </span> <span style={{ fontSize: "16px", fontWeight: 200 }}>Visualizations</span>
            </Typography>

            <Box sx={{ display: 'flex', gap: 1 }}>
              {["YTD", "QTD", "MTD"].map((label, idx) => (
                <FilterChip
                  key={label}
                  label={label}
                  idx={idx}
                  activeIdx={activeIdx}
                  onClick={setActiveIdx}
                />
              ))}
            </Box>
          </Box>

          <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
        </Box>
        <Grid
          container
          rowSpacing={2}
          columnSpacing={2}
          sx={{
            mt: "26px !important",
            alignItems: "stretch"   // keeps all cards same height
          }}
        >
          <Grid item xs={12} sm={6} md={3} sx={{
            pt: { xs: "0px !important", sm: "0px !important", md: "0px !important" }
          }} >
            <PieLegendCard title="Stock Amount by Sub Brand" data={pieDataSubBrand} />
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{
            pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
          }}>
            <PieLegendCard title="Stock Amount by Region" data={pieDataRegion} />
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{
            pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
          }} >
            <PieLegendCard title="OTIF Fails by Warehouse" data={pieDataWarehouse} />
          </Grid>

          <Grid item xs={12} sm={6} md={3} sx={{
            pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
          }}>
            <PieLegendCard title="OTIF Fails by Top 5 Customers" data={pieDataCustomers} />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: "34px !important" }}>
          <Grid item xs={12}>
            <MultiBarcharts
              title={overtime.title}
              xLabels={overtime.xLabels}
              series={overtime.series}
              dataMatrix={overtime.dataMatrix}
              yTicks={overtime.yTicks}
            />
          </Grid>
        </Grid>

        <Grid container sx={{ mt: "34px !important" }}>
          <Grid item xs={12}>
            <Barcharts
              title={otifFailsByWarehouse.title}
              xLabels={otifFailsByWarehouse.xLabels}
              series={otifFailsByWarehouse.series}
              dataMatrix={otifFailsByWarehouse.dataMatrix}
              yTicks={[0, 400, 800, 1200, 1600, 2000]}
              rounded={false}
              yAxisLabel="Count"
            />
          </Grid>
        </Grid>

        <Grid container sx={{ mt: "34px !important" }}>
          <Grid item xs={12}>
            <LineChartsale
              title={lineChartCasesData.title}
              xLabels={lineChartCasesData.xLabels}
              series={lineChartCasesData.series}
              dataMatrix={lineChartCasesData.dataMatrix}
              yTicks={lineChartCasesData.yTicks}
              yAxisLabel="Case Amount (M)"
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: "34px !important" }}>
          <Grid item xs={12}>
            <LineChartSubBrand
              title={lineChartSubBrandData.title}
              xLabels={lineChartSubBrandData.xLabels}
              series={lineChartSubBrandData.series}
              dataMatrix={lineChartSubBrandData.dataMatrix}
              yTicks={[0, 1, 2, 3, 4, 5]}
              yAxisLabel="Cases Ordered (M)"
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mt: '34px !important' }}>
          {/* LEFT CARD - USA MAP */}
          <Grid item xs={12} md={6} sx={{
            pt: { xs: "0px !important", sm: "0px !important", }
          }}>
            <TopSkuBarChart
              title={topSkuBackorderChartData.title}
              xLabels={topSkuBackorderChartData.xLabels}
              series={topSkuBackorderChartData.series}
              dataMatrix={topSkuBackorderChartData.dataMatrix}
              xTicks={[0, 500, 1000, 1500, 2000]}
            />

          </Grid>

          {/* RIGHT CARD - BAR CHART */}
          <Grid item xs={12} md={6} sx={{
            pt: { xs: "34px !important", sm: "34px !important", md: '0px !important' }
          }}>
            <TopSkuBarChart
              title={topStockedSkuChartData.title}
              xLabels={topStockedSkuChartData.xLabels}
              series={topStockedSkuChartData.series}
              dataMatrix={topStockedSkuChartData.dataMatrix}
              xTicks={[0, 1000, 2000, 3000, 4000]}
            />

          </Grid>
        </Grid>

      </Box>



    </Box>


  );
};

export default OperationsDashboard;